const animationDuration = 300

export default {
  animationDuration
}
